import { render, staticRenderFns } from "./PollNumberValue.vue?vue&type=template&id=6461c802&scoped=true"
import script from "./PollNumberValue.vue?vue&type=script&lang=js"
export * from "./PollNumberValue.vue?vue&type=script&lang=js"
import style0 from "./PollNumberValue.vue?vue&type=style&index=0&id=6461c802&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6461c802",
  null
  
)

export default component.exports